import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function PainRelief() {
  const painPoints = ['Bebé solo duerme en brazos', 'Despertares constantes', 'Agotamiento físico y mental', 'Consejos contradictorios', 'Culpa y frustración'];
  const reliefPoints = ['Rutina clara y estructurada', 'Pasos simples de aplicar', 'Guía 100% en español', 'Sin métodos extremos', 'Calma real para ambos'];
  return <section className="py-16 md:py-24 px-5 bg-white" data-id="element-87">
      <div className="max-w-4xl mx-auto" data-id="element-88">
        <motion.div className="text-center mb-12 md:mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-heading mb-6" data-id="element-90">
            No estás fallando.
            <br className="md:hidden" data-id="element-91" /> Solo te faltaba un plan claro.
          </h2>
          <p className="text-lg text-body max-w-2xl mx-auto leading-relaxed" data-id="element-92">
            Si tu bebé solo duerme en brazos, pelea las siestas o se despierta
            apenas lo acuestas, no significa que estés haciendo algo mal. Muchas
            veces solo falta entender su etapa y seguir una rutina simple.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-93">
          {/* Pain Column */}
          <motion.div className="bg-surface/50 rounded-3xl p-6 md:p-8 border border-surface" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-94">
            <h3 className="text-xl font-serif font-semibold text-heading mb-6 flex items-center" data-id="element-95">
              Lo que vives ahora
            </h3>
            <ul className="space-y-4" data-id="element-96">
              {painPoints.map((point, i) => <li key={i} className="flex items-start space-x-3" data-id="element-97">
                  <div className="mt-0.5 bg-rose/30 p-1 rounded-full shrink-0" data-id="element-98">
                    <X className="w-4 h-4 text-terracotta" data-id="element-99" />
                  </div>
                  <span className="text-body font-medium" data-id="element-100">{point}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Relief Column */}
          <motion.div className="bg-cream rounded-3xl p-6 md:p-8 border border-terracotta/20 shadow-soft relative overflow-hidden" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-101">
            <div className="absolute top-0 right-0 w-32 h-32 bg-rose/20 rounded-bl-full -z-10" data-id="element-102" />
            <h3 className="text-xl font-serif font-semibold text-heading mb-6 flex items-center" data-id="element-103">
              Lo que vas a tener
            </h3>
            <ul className="space-y-4" data-id="element-104">
              {reliefPoints.map((point, i) => <li key={i} className="flex items-start space-x-3" data-id="element-105">
                  <div className="mt-0.5 bg-terracotta/10 p-1 rounded-full shrink-0" data-id="element-106">
                    <Check className="w-4 h-4 text-terracotta" data-id="element-107" />
                  </div>
                  <span className="text-heading font-medium" data-id="element-108">{point}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}